const geocodeLatLng = (
  position: google.maps.LatLngLiteral,
  callback: (position: google.maps.LatLngLiteral, address: string) => void
) => {
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ location: position }, (results, status) => {
    if (status === "OK" && results && results[0]) {
      callback(position, results[0].formatted_address);
    } else {
      console.error("Geocoder failed due to: " + status);
    }
  });
};

export default geocodeLatLng;
